import React from 'react';
import { Input, InputContainer } from 'finform';

const InvestSearchActiveName = ({ search, setSearch }) => (
  <InputContainer
    style={{
      maxWidth: '200px',
      marginLeft: 'auto',
    }}
  >
    <Input placeholder="Название актива" value={search} onChange={setSearch} />
  </InputContainer>
);

export default InvestSearchActiveName;
